import ResultField from "../atoms/ResultField";

/**
 * ResultRow - 算出結果表示行
 * table の tbody 内で使用する (<tr> を返す)
 *
 * サイズ・フォント系は上位コンポーネントから props で受け取る。
 * デフォルト値は通常の使用に合わせた値を設定してある。
 *
 * @param {string} label          - 項目名 (例: '総売上')
 * @param {number} value          - 算出された数値
 * @param {string} labelClass     - ラベルセルのクラス
 * @param {string} cellClass      - 値セルの padding クラス
 * @param {string} widthClass     - 結果フィールドの幅クラス
 * @param {string} sizeClass      - 結果フィールドの padding / font-size クラス
 * @param {string} unit           - 単位ラベル (例: '円')
 * @param {string} unitClass      - 単位ラベルのスタイルクラス
 * @param {boolean} signed          - true のとき正の値に "+" を付与する（差額表示用）
 * @param {string} valueColorClass  - 値のテキストカラークラス (例: 'text-red-600')
 */
function ResultRow({
  label,
  value,
  labelClass = "px-4 py-3 text-sm text-right whitespace-nowrap",
  cellClass = "px-4 py-3",
  widthClass = "w-52",
  sizeClass = "px-2 py-1 text-sm",
  unit = "円",
  unitClass = "text-sm",
  trClassName = "",
  signed = false,
  valueColorClass = "",
}) {
  return (
    <tr className={trClassName}>
      <td className={labelClass}>{label}</td>
      <td className={cellClass}>
        <ResultField
          value={value}
          widthClass={widthClass}
          sizeClass={sizeClass}
          unit={unit}
          unitClass={unitClass}
          signed={signed}
          valueColorClass={valueColorClass}
        />
      </td>
    </tr>
  );
}

export default ResultRow;
